"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    '&::-webkit-scrollbar': {
      width: palette.gutter / 2 + 'px'
    },
    '&::-webkit-scrollbar:horizontal': {
      height: palette.gutter / 2 + 'px'
    },
    '&::-webkit-scrollbar-button': {
      display: 'none'
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      background: palette.elDivider,
      borderRadius: '100px',
      transition: "background ".concat(palette.transitionDuration, " ").concat(palette.transitionFunction),
      '&:hover': {
        background: palette.elDarkest
      }
    },
    '&::-webkit-scrollbar-corner': {
      display: 'none'
    },
    '&::-webkit-resizer': {
      display: 'none'
    }
  };
}